/* eslint-disable @typescript-eslint/no-explicit-any */
import { preprocessMarkdown } from 'components/Summary/Summary';
import { STRINGS } from 'config';
import { reportError, reportInfo } from 'util/datadog';

const {
  SUMMARY: {
    SET_CONSULATION_ID,
    START_SUMMARY_REQUEST,
    GET_SUMMARY,
    ERROR_SUMMARY_REQUEST,
    UPDATE_SUMMARY,
    RESET_SUMMARY_STATE,
  },
} = STRINGS.REDUCERS;

export type SummaryState = {
  consultationId: string;
  currentSummary: string;
  error: boolean;
  presentingComplaintHeading: string | null;
  finishedSummaryRequest: boolean;
  hasEditsMadeToSummary: boolean;
};

export const initialSummaryState: SummaryState = {
  consultationId: '',
  currentSummary: '',
  error: false,
  presentingComplaintHeading: null,
  finishedSummaryRequest: false,
  hasEditsMadeToSummary: false,
};

export const summaryReducer = (state: any, action: any) => {
  switch (action.type) {
    case SET_CONSULATION_ID: {
      return { ...state, consultationId: action.payload.consultationId };
    }
    case START_SUMMARY_REQUEST: {
      const { userId, consultationId } = action.payload;
      reportInfo('Summariser initiated', { userId, consultationId });
      return {
        ...state,
        currentSummary: '',
        presentingComplaintHeading: null,
        error: false,
        finishedSummaryRequest: false,
        hasEditsMadeToSummary: false,
      };
    }
    case GET_SUMMARY: {
      const { userId, consultationId, summary, title } = action.payload;
      reportInfo('Summariser generated', { userId, consultationId });
      const processedSummary = preprocessMarkdown(summary);
      return {
        ...state,
        currentSummary: processedSummary,
        presentingComplaintHeading: title,
        finishedSummaryRequest: true,
      };
    }
    case ERROR_SUMMARY_REQUEST: {
      const { error, consultationId } = action.payload;
      reportError(new Error('Error while retrieving summary'), { consultationId, error });
      return { ...state, error: true };
    }
    case RESET_SUMMARY_STATE: {
      return { ...initialSummaryState };
    }
    case UPDATE_SUMMARY: {
      const { summary } = action.payload;
      return { ...state, currentSummary: summary, hasEditsMadeToSummary: true };
    }
    default: {
      return state;
    }
  }
};
